import request from "./../utils/request";

export function getStatistics(data) {
    return request.post("/statistics", data, {
        timeout: 60 * 1000,
    });
}

export function getAgentActivities(data) {
    return request.post("/statistics/agent-activities", data);
}
